import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Partenaires from "./pages/Partenaires";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/partenaires" element={<Partenaires />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
